import React, { useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { toast } from "react-toastify"
import { useTranslation } from "react-i18next"

import { Switch } from "components"
import { setTemporaryOff } from "services"
import { toggleTemporaryOff } from "@redux"
import classes from "./SsTemporaryOff.module.scss"

const SsTemporaryOff = () => {
  const [t] = useTranslation()

  const temporaryOff =
    useSelector(state =>
      state.systemSettings.temporaryOff
    )

  const dispatch = useDispatch()

  const [sending, setSending] = useState()

  const handleChange = async () => {
    setSending(true)

    dispatch(toggleTemporaryOff())

    try {
      await setTemporaryOff({ temporaryOff: !temporaryOff })
    } catch (err) {
      console.log(err)

      toast.error(t("عملیات_انجام_نشد"))

      dispatch(toggleTemporaryOff())
    }

    setSending(false)
  }

  return (
    <div className={classes["row"]}>
      <span>{t("بستن_فروشگاه")}</span>
      <Switch
        disabled={sending}
        onClick={handleChange}
        checked={temporaryOff}
      />
    </div>
  )
}

export default SsTemporaryOff